<template>
  <my-header></my-header>
  <div class="contact-body">
    <div class="contact-left">
      <img src="../assets/contact.webp" alt="联系我们的图片" class="contact-image">
    </div>
    <div class="contact-right">
      <h1>{{ $t('contact.title') }}</h1>
      <ul>
        <li><i class="fas fa-envelope"></i><span>&nbsp;&nbsp;{{email}}</span></li>
        <li><i class="fas fa-map-marker-alt"></i><span>&nbsp;&nbsp;{{address}}</span></li>
        <li><i class="fas fa-phone"></i><span>&nbsp;&nbsp;{{phone}}</span></li>
        <li><i class="fab fa-instagram"></i><span>&nbsp;&nbsp;{{faceZhanghao}}</span></li>
        <li><i class="fab fa-facebook"></i><span>&nbsp;&nbsp;{{insZhanghao}}</span></li>
      </ul>
    </div>
  </div>
  <my-foot></my-foot>
</template>

<script>
import MyHeader from "@/components/MyHeader";
import MyFoot from "@/components/MyFoot"
export default {
  name: "ContactUs",
  data(){
    return{
      phone: "0577-85220619",
      email: "General-M@y-signal.com",
      address: "466 Jinhai Second Road, Wenzhou City",
      faceZhanghao: "Shang Yu",
      insZhanghao: "guosong268",
    }
  },
  components:{
    MyHeader,
    MyFoot
  },
  created() {
    window.scrollTo(0, 0);
  }
}
</script>

<style scoped>
.about-body {
  margin: 40px 0;
}

.contact-body {
  width: 80%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  padding: 20px;
  box-sizing: border-box; /* 确保padding不会增加总宽度 */
}

.contact-left {
  border-radius: 10px;
  overflow: hidden; /* 确保图片圆角显示正常 */
}

.contact-image {
  width: 100%;
  height: 500px;
  object-fit: cover; /* 保持图片比例并填充容器 */
}

.contact-right {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  justify-content: center; /* 垂直居中内容 */
}

.contact-right h1 {
  color: #333;
  margin-bottom: 25px;
  font-size: 28px;
}

.contact-right ul {
  list-style: none;
  text-align: left;
  margin: 0;
  padding: 0;
}

.contact-right ul li {
  margin: 15px 0;
  font-size: 1.1em;
  color: #666;
  line-height: 60px;
  font-weight: bold;
  font-size: 20px;
  transition: color 0.3s ease; /* 添加过渡效果 */
}

.contact-right ul li:hover {
  color: red;
}

.contact-right i {
  color: #007bff;
  width: 24px;
}

/* 手机端适配 */
@media (max-width: 768px) {
  .contact-body {
    width: 95%; /* 更宽的占比，减少边缘空白 */
    grid-template-columns: 1fr; /* 单列布局 */
    padding: 10px;
  }

  .contact-image {
    height: 300px; /* 减小图片高度 */
  }

  .contact-right {
    padding: 20px;
  }

  .contact-right h1 {
    font-size: 24px;
    margin-bottom: 15px;
    text-align: center; /* 标题居中 */
  }

  .contact-right ul li {
    font-size: 16px; /* 减小字体大小 */
    line-height: 40px; /* 减小行高 */
    padding-left: 5px; /* 适当内边距 */
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .contact-body {
    width: 90%;
  }

  .contact-image {
    height: 400px;
  }
}
</style>
